import './TrustBadges.css'

function TrustBadges() {
  return (
    <div className="trust-badges">
      <div className="trust-badge">
        <div className="trust-badge-number">700+</div>
        <div className="trust-badge-label">Successful Installations</div>
      </div>
      
      <div className="trust-badge">
        <div className="trust-badge-number">35+</div>
        <div className="trust-badge-label">Years Experience (Founded 1988)</div>
      </div>
    </div>
  )
}

export default TrustBadges
